// ComprehensiveInHomeCareSection.js
import React from "react";
import comprehensiveInHomeCareImage from "../assets/comprehensive-in-home-care-image.jpg";

const ComprehensiveInHomeCareSection = () => {
  const services = [
    "Safe transfers between bed, wheelchair, or toilet",
    "Emotional companionship and encouragement throughout the day",
    "Light housekeeping and home organisation for safety and accessibility",
    "Medication reminders and coordination with healthcare professionals",
    "Nutritious meal preparation and feeding assistance",
    "Sensitive and discreet bowel and bladder care",
    "Personal hygiene support, including bathing, dressing, and grooming",
    "Range-of-motion exercises and mobility assistance",
  ];

  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={comprehensiveInHomeCareImage}
              alt="Caregiver assisting man with cane outdoors"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Comprehensive In-Home Care for Lasting Comfort
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Living with a spinal cord injury can reshape every aspect of
                daily life, from mobility to emotional well-being. At Allawah
                Lodge, our specialised spinal cord injury care services are
                designed to provide consistent, compassionate support that helps
                clients live confidently and comfortably at home.
              </p>

              <p>
                Our skilled caregivers are trained to assist individuals with
                varying degrees of mobility, offering both practical and
                emotional support to enhance their overall well-being. Depending
                on your loved one's unique needs, our in-home care may include:
              </p>
            </div>

            <ul className="space-y-2 text-gray-700 font-light">
              {services.map((service, index) => (
                <li key={index} className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComprehensiveInHomeCareSection;
